import { TextCustomProps, TextAppearance, TextTag, TextSize, TextLineHeight, TextWeight } from "@vw-marketing/us-components";

export const labelMarksTextStyle: TextCustomProps = {
    appearance: TextAppearance.headline200,
    tag: TextTag.span,
    style: {
        fontSize: TextSize.TextSize12,
        lineHeight: TextLineHeight.TextLineHeight36,
        fontWeight: TextWeight.regular
    }
  }

  export const labelDistanceTextStyle: TextCustomProps = {
    appearance: TextAppearance.headline200,
    tag: TextTag.span,
    style: {
        fontSize: TextSize.TextSize12,
        lineHeight: TextLineHeight.TextLineHeight36,
        fontWeight: TextWeight.bold
    }
  }
